import './Primary.scss';

import { capitalize } from '@sonar-software/sonar-ts-lib';
import { FilterComponent } from './FilterComponent';
import { Flex } from 'antd';
import { getFilterId } from '../@arch/lib';

import { ApiCodeToggle, ApiCodeToggleQueryParams } from '@periscopes/general/filters';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { SearchInput, SearchInputRef } from '@ui/general';

export const PrimaryFilter: FilterComponent<string | undefined> = (props) => {
	const { format, id, label, metadata, onChange, params, placeholder, value } = props;
	const searchRef = useRef<SearchInputRef>(null);

	const internalValue = params[ metadata ?? '' ]?.value as string ?? '';
	const hasInternal = Boolean(internalValue);

	const [ toggledInternal, setToggledInternal ] = useState(hasInternal && !props.displayAsTag);

	const displayInternal = hasInternal || toggledInternal;

	const displayValue = displayInternal ? internalValue : value;

	useEffect(() => {
		if (searchRef.current) {
			searchRef.current.setText(displayValue ?? '');
		}
	}, [ displayValue ]);

	const baseLabel = capitalize(label ?? '');
	const adjustedLabel = displayInternal ? baseLabel.replace(COPY_SPECIFIC.NAME, COPY_SPECIFIC.API_NAME) : baseLabel;

	const handleToggle = useCallback((change: ApiCodeToggleQueryParams) => {
		onChange({
			[ metadata ?? 'Name' ]: {
				format,
				value: change.useInternal ? displayValue : ''
			},
			[ id ]: {
				format,
				value: change.useInternal ? '' : displayValue
			}
		});

		setToggledInternal(change.useInternal ?? false);
	}, [ displayValue, format, id, metadata, onChange ]);

	return (
		<FilterComponent
			className='primary-filter'
			{ ...props }
			label={ adjustedLabel }
			tagProps={ {
				id: displayInternal ? metadata ?? id : id
			} }
			value={ displayValue }>
			<Flex
				align='center'
				gap={ 8 }>
				<SearchInput
					className='filter'
					defaultValue={ displayValue }
					id={ getFilterId(id) }
					onChange={ (query = '') =>
						onChange({
							[ displayInternal ? metadata ?? id : id ]: {
								format,
								value: query
							}
						}) }
					placeholder={ placeholder ?? PLACEHOLDERS_COPY.FILTER_BY(adjustedLabel) }
					ref={ searchRef } />
				<ApiCodeToggle
					checked={ toggledInternal }
					onChange={ handleToggle } />
			</Flex>
		</FilterComponent>
	);
};
